<template>
    <div class="common-box flex-one">
         <div class="o-title border" v-if="title">待办提醒</div>
        <el-tabs v-model="status" type="card">
            <el-tab-pane label="待确认" :name="30"></el-tab-pane>
            <el-tab-pane label="进行中" :name="40"></el-tab-pane>
            <el-tab-pane label="已完成" :name="70"></el-tab-pane>
            <el-tab-pane v-if="permission.desk_audit" label="待审核" :name="50"></el-tab-pane>
        </el-tabs>
        <avue-crud :option="option" :table-loading="loading" :data="data" :page.sync="page" ref="crud" :permission="permissionList" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @error="error">
            <template slot-scope="scope" slot="menu">
                <!-- 该计划单详情 -->
                <el-button type="text" size="small" v-if="status == 30" @click.stop="handleView(scope.row,1)">详情</el-button>
                <!-- 确认是否认领该计划单 -->
                <el-button type="text" size="small" v-if="status == 30" @click.stop="comfirmHandle(scope.row)">确认</el-button>
                <!-- 完善计划单 添加具体计划 -->
                <el-button type="text" size="small" v-if="status == 40&&scope.row.status==1" @click.stop="handlePerfect(scope.row)">完善计划</el-button>
                <!-- 审核通过后 上传具体资料 -->
                <!-- &&scope.row.status == 60 -->

                <el-button type="text" size="small" v-if="status == 40&&(scope.row.status==7||scope.row.status==3)" @click.stop="handleView(scope.row,2)">计划实施</el-button>
                <!-- 查看详情订单 -->
                <el-button type="text" size="small" v-if="status == 70" @click.stop="handleView(scope.row,4)">查看</el-button>
                <!-- 审核通过后 上传具体资料 -->
                <el-button type="text" size="small" v-if="status == 50" @click.stop="handleView(scope.row,3)">去审核</el-button>
            </template>
            <template slot-scope="{row}" slot="orderInitNo">
                <div class="num-family">{{row.orderInitNo}}</div>
            </template>
        </avue-crud>
        <el-dialog title="订单详情" append-to-body width="80%" :visible.sync="orderDetailVisible" custom-class="common-dialog">
            <orderDetail :detail="detailInfo" :initOrderId="initOrderId" :status="orderStatus" :isOpt="isMode == 2" :isShenHe="isMode == 3" :printBtn="true" :isSuccess="isMode == 4" @close="orderDetailVisible=false;refreshChange()">
            </orderDetail>
        </el-dialog>
    </div>
</template>
<script>
import { toBeConfirmedList, ongoingList, completeList, toAuditList, confirmedHandle } from "@/api/order/orderinit"
import { getOrderInfo } from "@/api/order/index";
import { mapGetters } from "vuex";
import orderDetail from '@/views/desk/progress.vue'
export default {
    props:{
        title:{
            type:'Boolean',
            default:false
        }
    },
    components: {
        orderDetail
    },
    data() {
        return {
            orderStatus:'',
            initOrderId: '',
            isMode: true,
            orderDetailVisible: false,
            detailInfo: {},
            data: [],
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            option: {
                addBtn: false,
                editBtn: false,
                delBtn: false,
                refreshBtn: false,
                columnBtn: false,
                menuBtn: false,
                align: 'center',
                menuAlign: 'center',
                column: [{
                        label: "计划单号",
                        prop: "orderInitNumber",
                        width: 160
                    },
                    {
                        label: "类型",
                        prop: "type",
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'work_type'
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        dataType: "string"
                    }, {
                        label: "发布机构",
                        prop: "createDeptName",
                    },
                    {
                        label: "执行机构",
                        prop: "initPlanCreateDeptName",
                    },
                    {
                        label: "开始时间",
                        prop: "beginTime",
                        type: "datetime",
                        format: "yyyy-MM-dd",
                    }, {
                        label: "结束时间",
                        prop: "endTime",
                        type: "datetime",
                        format: "yyyy-MM-dd",
                    }
                ]
            },
            status: 30
        }
    },
    watch: {
        'status'() {
            this.$nextTick(() => {
                this.$refs.crud.columnInit();
                this.onLoad(this.page);
            })
        },
    },
    computed: {
        ...mapGetters(["permission"]),
        permissionList() {
            return {
                addBtn: this.vaildData(this.permission.desk_audit, false),
            };
        },
    },
    methods: {
        handleView(row, flag) {
            this.isMode = flag
            this.initOrderId = row.id
            this.orderStatus = row.status
            getOrderInfo(row.orderId).then(res => {
                this.detailInfo = res.data.data
                this.orderDetailVisible = true
            })
        },
        handleSuccessView(row) {
            this.$router.push({ path: '/order/detail/success', query: { id: row.id } });
        },
        // 编辑事件
        handleEdit(row) {
            this.$router.push({ path: '/desk/detail', query: { id: row.dossierId, orderId: row.id, isDetail: true } });
        },
        // 完善计划
        handlePerfect(row) {
            this.$router.push({ path: '/desk/entry', query: { id: row.id, orderId: row.orderId } });
        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        refreshChange() {
            this.onLoad(this.page);
        },
        onLoad(page, params = {}) {
            this.data = []
            this.page.total =0
            this.loading = true;
            if (this.status == 30) {
                toBeConfirmedList(page.currentPage, page.pageSize).then(res => {
                    const data = res.data.data;
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                });
            } else if (this.status == 40) {
                ongoingList(page.currentPage, page.pageSize).then(res => {
                    const data = res.data.data;
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                });
            } else if (this.status == 70) {
                completeList(page.currentPage, page.pageSize).then(res => {
                    const data = res.data.data;
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                });
            } else if (this.status == 50) {
                toAuditList(page.currentPage, page.pageSize).then(res => {
                    const data = res.data.data;
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                });
            }
        },
        // 确认事件
        comfirmHandle(row) {
            console.log(row)
            this.$confirm('是否确认认领该订单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                confirmedHandle(row.id).then(res => {
                    this.$message({
                        type: 'success',
                        message: '认领成功!'
                    });
                    this.refreshChange()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                })
            });
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style lang="scss" scoped>
@import "@/styles/moudles/desk.scss";

</style>
<style lang="scss">
.desk-wrapper {
    .avue-crud__menu {
        display: none
    }
}

</style>
